export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-08.63257a90.jpg";